import { PROYECT, api_get, api_post, api_put, api_delete } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp, buildCustomTableConfig } from "redux/actions/search/searchActions";
import { COVERAGES_ASSIGN_TYPES } from "redux/reducers/coveragesAssign/coveragesAssignTypes";
import { divideAndCeil } from "helpers/mathDictionary";
import { newDateWithTime } from "helpers/dateTools";

const {
    SET_NEW_ASSIGNED_COVERAGE,
    SET_ASSIGNED_COVERAGES,
    SET_DELETED_ASSIGNED_COVERAGE,
    SET_STATION_UNITS,
    DELETE_ASSIGNATION_MODE,
    SET_SELECTED_ASSIGNATION,
    EDIT_ASSIGNATION_MODE,
    NEW_ASSIGNATION,
    SET_EDITED_ASSIGNATION,
    SET_COVERAGES_ASSIGN_FILTERS
} = COVERAGES_ASSIGN_TYPES;

export function newAssignation() {
    return {
        type: NEW_ASSIGNATION
    };
}

export function deleteAssignationMode() {
    return {
        type: DELETE_ASSIGNATION_MODE
    };
}

export function editAssignationMode() {
    return {
        type: EDIT_ASSIGNATION_MODE
    };
}

export function setSelectedAssignation(id) {
    return {
        type: SET_SELECTED_ASSIGNATION,
        payload: id
    };
}

export const deleteAssignedCoverage = (id, callback) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/assign/${id}`
    return async (dispatch) => {
        dispatch(startRequestComp('deleteAssignedCoverage'))
        try {
            await api_delete(url);
            dispatch({
                type: SET_DELETED_ASSIGNED_COVERAGE,
                payload: id
            })
            dispatch(setSnackbar('La asignación se ha eliminado con éxito', 'success'))
            if (callback) callback(false)
        } catch (error) {
            dispatch(setSnackbar(error))
        } finally {
            dispatch(stopRequestComp('deleteAssignedCoverage'))
        }
    }
}

export const editAssignedCoverage = (id, form, callback, tableKey = "coveragesAssign") => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/assign`
    return async (dispatch, getState) => {
        dispatch(startRequestComp('editAssignedCoverage'))
        try {
            const resp = await api_put(url, { ...form, id });
            dispatch({
                type: SET_EDITED_ASSIGNATION,
                payload: resp
            })
            dispatch(setSnackbar('La asignación se ha modificado con éxito', 'success'))
            const { startDate, endDate, station } = getState().coveragesAssign;
            const page = getState().search.configTables[tableKey]?.page || 0;
            const size = getState().search.configTables[tableKey]?.pageSize || 10;
            dispatch(fetchCoveragesAssign({ startDate, endDate, station, page, limit: size, tableKey }))
            if (callback) callback()
        } catch (error) {
            dispatch(setSnackbar(error))
        } finally {
            dispatch(stopRequestComp('editAssignedCoverage'))
        }
    }
}

export const createNewAssignedCoverage = (form, callback, tableKey = "coveragesAssign") => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/assign`
    return async (dispatch, getState) => {
        dispatch(startRequestComp('newAssignedCoverage'))
        try {
            const resp = await api_post(url, form);
            dispatch({
                type: SET_NEW_ASSIGNED_COVERAGE,
                payload: resp
            })
            dispatch(setSnackbar('La cobertura se ha asignado con éxito', 'success'))
            const { startDate, endDate, station } = getState().coveragesAssign;
            const size = getState().search.configTables[tableKey]?.pageSize || 10;
            dispatch(fetchCoveragesAssign({ startDate, endDate, station, page: 0, limit: size, tableKey }))
            if (callback) callback()
        } catch (error) {
            dispatch(setSnackbar(error))
        } finally {
            dispatch(stopRequestComp('newAssignedCoverage'))
        }
    }
}

export const setCoveragesAssignFilters = (key = "", data) => ({
    type: SET_COVERAGES_ASSIGN_FILTERS,
    payload: { data, key }
});

export const fetchCoveragesAssign = ({ startDate, endDate, station, page = 0, limit = 10, tableKey = "" } = {}) => async dispatch => {
    dispatch(startRequestComp("fetchCoveragesAssign"));
    const newPage = Number(page) + 1;
    try {
        const params = new URLSearchParams({ page: newPage, limit });
        if (startDate) params.set("start", startDate);
        if (endDate) params.set("end", endDate);
        if (station?.id) params.set("stations", station.id);
        const response = await api_get(`${process.env.REACT_APP_URL}${PROYECT}/routes/assign?${params}`);

        const newPagination = {
            pageSize: response.pagination?.limit || 10,
            page: (response.pagination?.page || 1) - 1,
            sorted: [],
            pages: divideAndCeil(
                Number(response.pagination?.total),
                Number(response.pagination?.limit)
            )
        };

        dispatch({
            type: SET_ASSIGNED_COVERAGES,
            payload: (response.data || response).map(item => ({
                ...item,
                date: item.date ? newDateWithTime({ date: item.date, format: true }) : null
            }))
        });

        if (tableKey) dispatch(buildCustomTableConfig(tableKey, newPagination));
    } catch (error) {
        dispatch(setSnackbar(error));
    } finally {
        dispatch(stopRequestComp("fetchCoveragesAssign"));
    }
};

export const fetchStationUnits = idStation => async dispatch => {
    dispatch(startRequestComp("fetchStationUnits"));
    try {
        const stationUnits = await api_get(`${process.env.REACT_APP_URL}${PROYECT}/units/stations/${idStation}`);
        dispatch({
            type: SET_STATION_UNITS,
            payload: stationUnits
        });
    } catch (error) {
        dispatch(setSnackbar(error));
    } finally {
        dispatch(stopRequestComp("fetchStationUnits"));
    }
};